import axios from 'axios';

const storage = {};
export const loadQuestions = async locale => {
  if (!storage[locale]) {
    try {
      const response = await axios.get(`/assets/questions_${locale}.json`);
      storage[locale] = response.data;
      return response.data;
    } catch (error) {
      console.error(error);
    }
  } else {
    return storage[locale];
  }
};



// WEBPACK FOOTER //
// ./src/services/data.ts